/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import { client, withUnwrap } from '../.kubb/client'
import type { AuthLogoutOptions, AuthLogoutResponses } from '../models/AuthLogout'
import { authLogoutResponseSchema } from '../schemas/authLogoutSchema'

/**
 * @summary Revoke the current refresh token and clear the cookie.
 * {@link /api/v4/auth/logout}
 */
export function authLogout<ThrowOnError extends boolean = true>(
  options: Options<AuthLogoutOptions, ThrowOnError> = {}
): Unwrappable<RequestResult<AuthLogoutResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/api/v4/auth/logout',
      validator: { response: authLogoutResponseSchema },
      ...config,
    }) as Promise<RequestResult<AuthLogoutResponses, ThrowOnError>>
  )
}
